import { COLOR_PALETTE } from 'constants/ui';

export const getCardStyles =
  ({ isRunning }) =>
  ({ palette }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '16px',
    borderRadius: '8px',
    border: `1px solid ${palette.border.light}`,
    backgroundColor: isRunning ? palette.background.secondary : palette.background.paper,
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',

    '&:hover': {
      borderColor: palette.border.input,
      boxShadow: palette.shadow.s,
    },
  });

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '16px',
};

export const headerLeftStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flex: 1,
  minWidth: 0,
};

export const colorDotStyles = ({ backgroundColor }) => ({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor,
  flexShrink: 0,
});

export const nameStyles = {
  color: ({ palette }) => palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const headerRightStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
};

export const descriptionStyles = {
  color: ({ palette }) => palette.text.dark,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
};

export const sublineStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const runningRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '8px 12px',
  borderRadius: '6px',
  backgroundColor: COLOR_PALETTE.BLUE[1],
  color: COLOR_PALETTE.BLUE[8],
};
